import { FC } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { useFragment } from 'react-relay';

import MultiSelect, { MultiSelectProps } from 'components/MultiSelect';
import { CategoriesSelect_data$key } from '__generated__/CategoriesSelect_data.graphql';

type Props = {
  data: CategoriesSelect_data$key;
} & MultiSelectProps;

const CategoriesSelect: FC<Props> = ({ data, ...rest }) => {
  const { allCategories } = useFragment(
    graphql`
      fragment CategoriesSelect_data on Query {
        allCategories {
          id
          name
        }
      }
    `,
    data
  );

  return <MultiSelect {...rest} options={allCategories} />;
};

export default CategoriesSelect;
